/* ══════════════════════════════════════════════════════════════════════════
 * CLS-DK — Student Club product data (Danish mock)
 * Re-uses the product imagery harvested from Figma for ABC-SE student club.
 * ══════════════════════════════════════════════════════════════════════════ */

import p1 from '../../../../assets/abc-se/student-club/product-1.png';
import p2 from '../../../../assets/abc-se/student-club/product-2.png';
import p3 from '../../../../assets/abc-se/student-club/product-3.png';
import p4 from '../../../../assets/abc-se/student-club/product-4.png';
import p5 from '../../../../assets/abc-se/student-club/product-5.png';
import p6 from '../../../../assets/abc-se/student-club/product-6.png';
import p7 from '../../../../assets/abc-se/student-club/product-7.png';
import p8 from '../../../../assets/abc-se/student-club/product-8.png';
import p9 from '../../../../assets/abc-se/student-club/product-9.png';
import p10 from '../../../../assets/abc-se/student-club/product-10.png';
import p11 from '../../../../assets/abc-se/student-club/product-11.png';
import p12 from '../../../../assets/abc-se/student-club/product-12.png';

export const CLUB_PRODUCTS_PRIMARY = [
  { id: 'hoodie-navy',     image: p1,  imageAlt: 'Hoodie Navy',     title: 'HOODIE NAVY',     price: '159,-' },
  { id: 'hoodie-grey',     image: p2,  imageAlt: 'Hoodie Grey',     title: 'HOODIE GREY',     price: '159,-' },
  { id: 'crewneck-navy',   image: p3,  imageAlt: 'Crewneck Navy',   title: 'CREWNECK NAVY',   price: '159,-' },
  { id: 'crewneck-grey',   image: p4,  imageAlt: 'Crewneck Grey',   title: 'CREWNECK GREY',   price: '159,-' },
  { id: 'whistle',         image: p5,  imageAlt: 'Whistle',         title: 'FLØJTE',          price: '159,-' },
  { id: 'bear',            image: p6,  imageAlt: 'Bear',            title: 'BAMSE',           price: '159,-' },
  { id: 'banana',          image: p7,  imageAlt: 'Banana',          title: 'BANAN',           price: '159,-' },
  { id: 'balloons',        image: p8,  imageAlt: 'Balloons',        title: 'BALLONER',        price: '159,-' },
];

export const CLUB_PRODUCTS_SECONDARY = [
  { id: 'elephant',        image: p9,  imageAlt: 'Elephant',        title: 'ELEFANT',         price: '159,-' },
  { id: 'party-decor',     image: p10, imageAlt: 'Party decor',     title: 'FESTDEKORATION',  price: '159,-' },
  { id: 'confetti',        image: p11, imageAlt: 'Confetti',        title: 'KONFETTI',        price: '159,-' },
  { id: 'celebration-set', image: p12, imageAlt: 'Celebration set', title: 'FESTSÆT',         price: '159,-' },
];
